import { ITransformTemplate } from 'smarthub-common'

export const transforms: ITransformTemplate[] = []
